import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Container } from '@mui/material';
import { BankingService } from 'services';
import { IRootState } from 'stores';
import { BankingState, setAccounts } from 'stores/banking';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router';
import { EAccountStatus } from 'common/accounts.interface';
import { TabNavigation } from './components/TabNavigation';
import { BankingVisibilityProvider } from './contexts/BankingVisibilityContext';

const bankingService = new BankingService();

const AccountDashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const { accounts } = useSelector<IRootState, BankingState>(({ banking }) => banking);

  useEffect(() => {
    const fetchAccounts = async () => {
      setLoading(true);

      try {
        const accountsByPerson = await bankingService.getAccounts();

        if (accountsByPerson.length < 2) {
          // ? Must have both types of accounts, if not redirect to /banking
          navigate('/banking');
        }

        if (!accountsByPerson.every((account) => account.status === EAccountStatus.ACTIVE)) {
          // ? Must have all accounts approved, if not redirect to /banking
          navigate('/banking');
        }

        dispatch(setAccounts(accountsByPerson));
      } catch (error) {
        // TODO: Handle error
      } finally {
        setLoading(false);
      }
    };

    fetchAccounts();
  }, []);

  return (
    <BankingVisibilityProvider>
      <Box sx={{ bgcolor: '#fff', minHeight: '100vh' }}>
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
            <CircularProgress size={24} />
          </Box>
        )}

        {!loading && accounts.length > 0 && (
          <Container maxWidth="xl" sx={{ py: 3 }}>
            <TabNavigation />
            <Outlet />
          </Container>
        )}
      </Box>
    </BankingVisibilityProvider>
  );
};

export default AccountDashboardPage;
